var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeaturesIcon1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 62.451,
    height: 45.27,
    viewBox: "0 0 62.451 45.27",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    "data-name": "\\uD569\\uCE58\\uAE30 230",
    d: "M20.879 45.269 7.807 22.635 20.879 0h26.133l8.308 14.387h-3.951L45.038 3.423H22.854L11.762 22.635l11.092 19.212h22.184l6.331-10.964h3.951l-8.308 14.386zm-7.813 0L0 22.635 13.066 0h3.952l-3.373 5.848-9.7 16.786L14.67 41.2l2.258 4.073zm39.715-16.832h-1.055l4.091-4.091H33.711v-3.423h22.106l-1.6-1.6-2.493-2.493h4.929l.186.191 5.61 5.611-5.61 5.613-.186.189z",
    style: {
      fill: "#fff"
    }
  }));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeaturesIcon1);
export default __webpack_public_path__ + "static/media/features-icon-1.77e6dcf5f319d422eb1662a230d6e8f2.svg";
export { ForwardRef as ReactComponent };